import {useShallow} from 'zustand/react/shallow';

import {useQuestionTranslationStore} from './TranslationSection/TranslationStore';
import {gradedItemText} from './TranslationSection/TranslationText';

export type GradedItemCopy = typeof gradedItemText;

export const englishGradedItemCopy: GradedItemCopy = {
  correct: 'Correct',
  incorrect: 'Incorrect',
  noAnswer: 'No answer',
  correctAnswerLabel: 'Correct answer:'
};

/** The copy for graded items, in Spanish while the student has the question's translation on. */
export const useGradedItemCopy = (): GradedItemCopy => {
  const showTranslations = useQuestionTranslationStore(
    useShallow((state) => state.showTranslations && state.translationSettings.question)
  );
  return showTranslations ? gradedItemText : englishGradedItemCopy;
};

/** What a screen reader hears before a graded item: "Correct: " or "Incorrect: ". */
export const verdictText = (copy: GradedItemCopy, isCorrect: boolean): string =>
  `${isCorrect ? copy.correct : copy.incorrect}: `;

/** What a screen reader hears in a graded blank the student left empty. */
export const noAnswerText = (copy: GradedItemCopy): string => `${copy.noAnswer}.`;
